import React from 'react';
import { CheckCircle2, AlertCircle, Clock, XCircle, AlertTriangle, Info } from 'lucide-react';
interface StatusPillProps {
  status: string;
  type: 'neutral' | 'blue' | 'amber' | 'red' | 'green' | 'gray';
}
export function StatusPill({
  status,
  type
}: StatusPillProps) {
  const config = {
    neutral: {
      bg: 'bg-slate-100',
      text: 'text-slate-700',
      border: 'border-slate-200',
      icon: Info
    },
    blue: {
      bg: 'bg-blue-50',
      text: 'text-blue-700',
      border: 'border-blue-200',
      icon: Clock
    },
    amber: {
      bg: 'bg-amber-50',
      text: 'text-amber-700',
      border: 'border-amber-200',
      icon: AlertTriangle
    },
    red: {
      bg: 'bg-red-50',
      text: 'text-red-700',
      border: 'border-red-200',
      icon: AlertCircle
    },
    green: {
      bg: 'bg-emerald-50',
      text: 'text-emerald-700',
      border: 'border-emerald-200',
      icon: CheckCircle2
    },
    gray: {
      bg: 'bg-gray-100',
      text: 'text-gray-700',
      border: 'border-gray-200',
      icon: XCircle
    }
  };
  const {
    bg,
    text,
    border,
    icon: Icon
  } = config[type];
  return <div className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full border ${bg} ${text} ${border} text-xs font-medium whitespace-nowrap`} data-id="element-76">
      <Icon className="w-3.5 h-3.5" data-id="element-77" />
      {status}
    </div>;
}